<template>
    <div v-if="showBrowserWarning" class="top-container no-print">
      <div class="content">
        <div class="info">
          <div class="icon">
            <img :src="icon" />
          </div>
          <div class="text">
            {{ $t('browserWarning.title1') }} <a target="_blank" href="https://www.google.com/chrome/">{{ $t('browserWarning.chrome') }}</a> {{$t('browserWarning.or')}} <a target="_blank" href="https://www.apple.com/safari/">{{ $t('browserWarning.safari') }}</a> {{ $t('browserWarning.title2') }}
          </div>
        </div>
        <div class="icon close">
          <a @click="closeBrowserWarning">
            <i class="fa-light fa-close"></i>
          </a>
        </div>
      </div>
    </div>
</template>

<script>
import theme from '@/mixins/theme'
import auth from '@/mixins/auth'
import { detect } from 'detect-browser'
import imageProxy from '@/libs/image-proxy'

export default {
  components: {
  },
  mixins: [auth, theme],
  computed: {
    showBrowserWarning: function () {
      return this.$store.getters.shouldShowBrowserWarning && !this.isSupportedBrowser && this.$isIsef
    },
    isSupportedBrowser: function () {
      const browser = detect()
      // ios for Safari in iOS
      // crios Chrome in iOS
      return ['chrome', 'firefox', 'safari', 'ios', 'crios'].includes(browser.name)
    },
    icon: function () {
      return imageProxy.proxy('/static/icons/browser.png', { height: 18, width: 23 })
    }
  },
  mounted: function () {
    this.$store.dispatch('checkBrowserWarning')
  },
  methods: {
    closeBrowserWarning: function () {
      this.$store.dispatch('closeBrowserWarning', false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
@import '~@/styles/projectboard-mixins';
$tile-height: $nav-height-px;
$tile-width: 61px; // 61px is hard-coded below inside of a calc()
$tile-width-m: 52px;
$tile-width-xl: 75px; //For the sign in button
$tile-width-m-xl: 70px; // For the sign in button on mobile
$category-width-more: 103px;
$category-width-communities: 166px;
$category-width-exhibitHall: 166px;

/* General styles */
img {
  max-width: 100%;
  max-height: 100%;
}

// Makes only the placeholders italics, but must be defined seperaltely
::-webkit-input-placeholder {
  font-style: italic;
}

:-moz-placeholder {
  font-style: italic;
}

::-moz-placeholder {
  font-style: italic;
}

:-ms-input-placeholder {
  font-style: italic;
}

.notification {
  border-radius: 0;
}

.top-container {
  .content {
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F2F2F2;
    position: relative;
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-left: auto;
    }
    .icon {
      margin-right: 0.5rem;
      min-width: 1.5rem;
    }
    .text {
      font-size: 0.75rem;
    }
    .close {
      margin-right: 0;
      margin-left: auto;
      justify-content: flex-end;
    }
  }
}

@media only screen and (max-width: 600px)  {
    .top-container {
      .content {
        padding: 0.75rem 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #F2F2F2;
        position: relative;
      .icon {
        margin-right: 0.5rem;
      }
      .text {
        font-size: 0.75rem;
      }
    }
  }
}

</style>
